import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { BuyCreditsPage } from './buy-credits';

@NgModule({
  declarations: [
    BuyCreditsPage,
  ],
  imports: [
    IonicPageModule.forChild(BuyCreditsPage),
  ],
})
export class BuyCreditsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/buy-credits/buy-credits.module.ts